import 'arrayq';
import { PureConnect, React } from '../react';
import { Modal } from '../note/modal/index';
import Input from 'react-toolbox/lib/input';
import { ParticipantSelectionForUsergroups } from '../note/noteParticipantSelectPopup/input';
import { usergroupEditor } from './resource';
import cx from './style.less';
import selectorsParticipantPopup from '../note/noteParticipantSelectPopup/selectors';
import { participantsResource } from '../participant/resource';
import { buttonUsergroupEditenDeelnemers } from '../focuslock/actions/UPDATE_BUTTON_NO';
import UPDATE_BUTTON_NO from '../focuslock/actions/UPDATE_BUTTON_NO';
import SHOW_PARTICIPANT_POPUP from '../note/noteParticipantSelectPopup/actions/SHOW';
import FocusLockFocusGuard from '../focuslock/focuslockext';
import windowSelectors from '../window/selectors';
import { IUsergroup } from '../types';
import authmng from '../auth/selectors';
import { Btn } from '../react-toolbox-redesign/button';
import { hack } from '../browser/launch';
const maxNameLength = 200;

export default PureConnect(`UsergroupEditModal`)(
    (state) => ({
        creating: usergroupEditor.selectors.creating(state),
        item: usergroupEditor.selectors.item(state),
        updating: usergroupEditor.selectors.updating(state),      
        origin: state.notemenu.origin,
        participantPopupVisible: selectorsParticipantPopup.visible(state),    
        screenSmall: windowSelectors.small(state),   
        accountmng: authmng.accountmanager(state),
    }),
    (dispatch) => ({ 
        cancel: () => dispatch(usergroupEditor.actions.RESET({ })),
        cancelCreating: () => {            
            dispatch(usergroupEditor.actions.CREATE_CANCEL({ }));},
        cancelUpdating: () => {
            dispatch(usergroupEditor.actions.UPDATE_CANCEL({ }));},
        change: (item: IUsergroup | any) => { dispatch(usergroupEditor.actions.APPLY({ item }));},
        saveCreating: (item: IUsergroup) => { 
            dispatch(usergroupEditor.actions.CREATE_CONTINUE({ item })); },
        saveUpdating: (item: IUsergroup) => {
            dispatch(usergroupEditor.actions.UPDATE_CONTINUE({ item })); },
        showParticipantPopUp: () => {dispatch(SHOW_PARTICIPANT_POPUP({itemno: -1}));},
        updateButtonFocus: (buttonNr: number, origin: number, itm: IUsergroup) => {
            dispatch(UPDATE_BUTTON_NO({buttonNo: buttonNr, origin: origin, buttonAction: undefined, lasttoucheditem:itm})); 
        },
        deleteUsergroup: (item: IUsergroup) => dispatch(usergroupEditor.actions.DELETE({ item })),
    }),
    ({ creating, updating, item, origin, screenSmall, accountmng, updateButtonFocus, deleteUsergroup, change, saveCreating, cancelCreating, saveUpdating, cancelUpdating, showParticipantPopUp, participantPopupVisible }) => {

        const onSelect = (item: IUsergroup) => {
            item.allTenantUsers = !item.allTenantUsers;
            change(item);
        };
        return (
            <Modal 
                onEscKeyDown={!participantPopupVisible? 
                        (creating ? ()=> cancelCreating() : ()=> cancelUpdating()): () => {}} 
                    visible={((creating || updating) && item && !item.type)} 
                    type={screenSmall ? 'smallscreen': 'center2nd' }
                    backdrop={true}
                    header={<div className={cx('usergroup-title')}>{ (updating ? 'Groep bewerken' : 'Groep toevoegen')}</div>}
                >                   
                <div className={cx((!creating && !updating) ? 'wcag-invisible' : '', 'fields-container')}  
                    aria-hidden={!(creating || updating)} 
                    aria-labelledby= "Maak een gebruikersgroep aan">
                    <FocusLockFocusGuard
                        disabled={!(creating || updating)}>   
                        <div className={cx('usergroup-container')}>
                            <div className={cx('input-naam-gebruikersgroep')}>
                                <span className={cx('input-label')}>Groep<span className={cx('star')}>*</span></span>
                                    <Input  
                                    className={cx('usergroup-input')}
                                    type="text"
                                    name="name"
                                    value={item.name}
                                    maxLength={maxNameLength}
                                    multiline
                                    onChange={(value: string) => change({ name: value })}
                                    floating />                        
                            </div>        
                        
                            <div className={cx('default-checkbox-div', 'check-box-selection', !accountmng ? 'wcag-invisible': '')} 
                                tabIndex={-1}>
                                <input type="checkbox" 
                                    className={cx('default-checkbox')} 
                                    tabIndex={-1}  
                                    checked={item.allTenantUsers || false}
                                    onChange={() => onSelect(item)}
                                    aria-hidden={true}/>
                                <div role="checkbox" 
                                    className={cx('checkmark')}
                                    aria-checked={item.allTenantUsers ? 'true': 'false'}
                                    tabIndex={0}
                                    onKeyPress={(ev: any)=> { if (ev.key==='Enter') { onSelect(item);}}}
                                    onClick={() => onSelect(item)}>
                                </div> 
                                <span>Organisatiebreed toegankelijk</span>
                            </div>
                        </div>
                        <ParticipantSelectionForUsergroups  
                            selectedparticipantsIDs={item.userIDs}
                            selectedparticipantgroupIDs={[]}                                    
                            participantPopupVisible={participantPopupVisible}
                            onChange={(c) => { 
                                change({ userIDs: c ? c : undefined }); 
                            }}   
                            onChangeParticipantGroups={(d) => { 
                                change({ particpantgroupIDs: d ? d : undefined }); 
                            }}                                      
                            onAbort={() => { updateButtonFocus(buttonUsergroupEditenDeelnemers, origin, item);}} 
                            onSave={() => { updateButtonFocus(buttonUsergroupEditenDeelnemers, origin, item);}}
                            label={ '' } />                         
                        <div className={cx('content-buttons-container')}>
                            <Btn
                                type="button"
                                className={'btn'}
                                extraClassNames={'secondary-btn'}
                                aria-label={'Verwijder groep'}
                                aria-haspopup={false}
                                tabIndex={0}
                                onKeyDown={(evt: any) => {
                                    handleEnters(evt, () => deleteUsergroup(item));
                                }}
                                onClick={() => deleteUsergroup(item)}>
                                <span>VERWIJDER GROEP</span>
                            </Btn>
                        </div>
                         
                        <UsergroupEditModalButtons></UsergroupEditModalButtons>
                    </FocusLockFocusGuard>
                </div>         
            </Modal> 
        );
});

export const UsergroupEditModalButtons = PureConnect(`UsergroupEditModalButtons`)(
    (state) => ({
        creating: usergroupEditor.selectors.creating(state),
        item: usergroupEditor.selectors.item(state),
        updating: usergroupEditor.selectors.updating(state),
        usergroupowner: participantsResource.selectors.items(state).qFirst((itm) => itm.isUser),
        origin: state.notemenu.origin,
        selectNote: state.selection.creating,
        participantPopupVisible: selectorsParticipantPopup.visible(state),    
        screenSmall: windowSelectors.small(state),   
    }),
    (dispatch) => ({
        cancel: () => dispatch(usergroupEditor.actions.RESET({ })),
        cancelCreating: () => {            
            dispatch(usergroupEditor.actions.CREATE_CANCEL({ }));},
        cancelUpdating: () => {
            dispatch(usergroupEditor.actions.UPDATE_CANCEL({ }));},
        change: (item: IUsergroup | any) => { dispatch(usergroupEditor.actions.APPLY({ item }));},
        saveCreating: (item: IUsergroup) => {             
            item = fixNoteDevelopmentJsonServer(item, true);
            dispatch(usergroupEditor.actions.CREATE_CONTINUE({ item })); },
        saveUpdating: (item: IUsergroup) => {            
            item = fixNoteDevelopmentJsonServer(item, false);
            dispatch(usergroupEditor.actions.UPDATE_CONTINUE({ item })); },
        showParticipantPopUp: () => {dispatch(SHOW_PARTICIPANT_POPUP({itemno: -1}));},
        updateButtonFocus: (buttonNr: number, origin: number, itm: IUsergroup) => {
            dispatch(UPDATE_BUTTON_NO({buttonNo: buttonNr, origin: origin, buttonAction: undefined, lasttoucheditem:itm})); 
        },
    }),
    ({ creating, updating, item, saveCreating, cancelCreating, saveUpdating, cancelUpdating }) => {
        var visible = (creating || updating);     
        return (
            <div className={cx('bottom-panel', (!visible) ? 'wcag-invisible' : '')}
                aria-hidden={!(visible)}
                aria-labelledby="Maak een gebruikersgroep aan">
                {/* WCAG (button):
                            1) no role; they are buttons
                            2) focussable (Tab)
                            3) toggle function: n/a (when true use aria-checked)
                            4) aria-expanded: n/a
                            5) aria-haspopup: n/a  
                            6) aria-labelledby/aria-describedby: ref to label
                            7) icon of button is explained by tekst-> aria-hidden*/}
                <div className={cx('bottom-buttons')}>
                    <div className={cx('buttons-container')}>
                        <Btn
                            type="button"
                            className={'btn'}
                            extraClassNames={'secondary-btn'}
                            aria-label={'Annuleren'}
                            aria-haspopup={false}
                            tabIndex={0}
                            onKeyDown={(evt: any) => {
                                handleEnters(evt,
                                    creating ?
                                        () => { cancelCreating(); } :
                                        () => { cancelUpdating(); });
                            }}
                            onClick={creating ?
                                () => { cancelCreating(); } :
                                () => { cancelUpdating(); }}
                        >
                            <span>Annuleren</span>
                        </Btn>

                        <Btn
                            type="button"
                            className={'btn'}
                            aria-label={'Opslaan'}
                            aria-haspopup={false}
                            tabIndex={item.name ? 0 : -1}
                            disabled={!item.name}
                            onKeyDown={(evt: any) => {
                                handleEnters(evt, creating ?
                                    () => saveCreating(item) :
                                    () => saveUpdating(item));
                            }}
                            onClick={creating ?
                                () => saveCreating(item) :
                                () => saveUpdating(item)}
                        >
                            <span>Opslaan</span>
                        </Btn>
                    </div>

                </div>
            </div>

        );
});

function handleEnters(evt: any, funct: ()=>void) {
    if (evt.key==='Enter') {evt.preventDefault(); funct();}
}   

function fixNoteDevelopmentJsonServer(item: IUsergroup, create: boolean) {

    return item;
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/usergroup/editModal.tsx